// extracted by mini-css-extract-plugin
module.exports = {"tickerDiv":"styles_tickerDiv__Op2sk","phrase":"styles_phrase__Qcx4y"};